import React from 'react';
import PropTypes from 'prop-types';

import { Button, Spacer, Flex } from '@zillow/constellation';

const propTypes = {
    pager: PropTypes.object,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    onLoadMoreClick: PropTypes.func.isRequired,
};

const defaultProps = {
    pager: {
        startKey: 0,
        endKey: 0,
        hasMore: false,
    },
    text: 'Load more',
    disabled: false,
};

const InfiniteScroller = ({
    pager,
    text,
    disabled,
    onLoadMoreClick,
}) => {
    const { hasMore } = pager;

    const handleLoadMoreClick = () => {
        const { endKey } = pager;
        onLoadMoreClick(endKey);
    };

    return (
        <div>
            {hasMore && (
                <Flex display="flex" justifyContent="center">
                    <Spacer marginY="xs">
                        <Button
                            buttonType="primary"
                            onClick={disabled ? null : handleLoadMoreClick}
                            disabled={disabled}
                        >
                            {text}
                        </Button>
                    </Spacer>
                </Flex>
            )}
        </div>
    );
};

InfiniteScroller.propTypes = propTypes;
InfiniteScroller.defaultProps = defaultProps;

export default InfiniteScroller;
